import React, { Component } from 'react';
import Shimmer from 'sushiweb/Shimmer';
import { Check } from 'sushiweb/Icons';
import {
  Button,
  RadioGroup,
  Heading,
  SubHeading,
  CheckboxList,
} from '../../../../UiKit';
import { MultiSelectView } from '../../../widgets/ReportIssue/Issues/common';
import { grey } from 'sushiweb/tokens/color';
import { getFormData } from '../../../commons/CommonMethods';
import './WoApproveImage.scss';

export default class WoApproveImage extends Component {
  render() {
    const { handoverData } = this.props;
    return (
      <div className='row'>
        {!handoverData ? (
          <Shimmer height='150px' width='100%' />
        ) : (
          <WoApproveImageComp {...this.props} />
        )}
      </div>
    );
  }
}

class WoApproveImageComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedReason: null,
      requesteditems: null,
      comment: '',
      nestedRadio: null,
      dropdown: null,
      selectedDropdownVal: '',
      nestedDropdown: null,
      selectednestedDropdownVal: '',
      selectedNestedReason: null,
      dropdownError: false,
      dropdownErrorText: '',
      secondNestedRadio: null,
      selectSecondNestedOption: '',
      nestedCheckbox: null,
      selectNestedCheckbox: null,
    };
    this.timerID1 = null;
    this.timerID2 = null;
    this.timerID3 = null;
  }

  shouldComponentUpdate = (prevState, nextState) => {
    const { handoverData } = this.props;
    if (prevState.handoverData === handoverData && nextState === this.state)
      return false;
    return true;
  };

  componentWillUnmount = () => {
    clearTimeout(this.timerID1);
    clearTimeout(this.timerID2);
    clearTimeout(this.timerID3);
  };

  getImages = (images) => {
    return images && images.map((image) => ({ src: image }));
  };

  getReasons = (items) => {
    return (
      items &&
      items.map((item) => {
        return {
          text: item.display_text,
          value: item.tag,
        };
      })
    );
  };
  selectDropdown = (value) => {
    this.setState({
      selectedDropdownVal: value,
      dropdownError: false,
      dropdownErrorText: '',
    });
  };

  selectOption = (selectedReason, item) => {
    this.setState({
      nestedRadio: null,
      dropdown: null,
      selectedDropdownVal: '',
      selectedNestedReason: null,
      nestedCheckbox: null,
    });
    this.timerID1 = setTimeout(() => {
      this.setState({
        selectedReason: selectedReason,
        nestedRadio: (item && item.radio) || null,
        dropdown: (item && item.dropdown) || null,
        nestedCheckbox: (item && item.check_box) || null,
      });
    }, 0);
  };

  selectNestedCheckboxOption = (selectedNestedReason) => {
    this.setState({
      selectNestedCheckbox: selectedNestedReason,
    });
  };

  selectNestedDropdown = (value) => {
    this.setState({
      selectednestedDropdownVal: value,
      dropdownError: false,
      dropdownErrorText: '',
    });
  };

  selectNestedOption = (selectedReason, item) => {
    this.setState({
      nestedDropdown: null,
      selectednestedDropdownVal: '',
    });
    this.timerID2 = setTimeout(() => {
      this.setState({
        selectedNestedReason: selectedReason,
        nestedDropdown: (item && item.dropdown) || null,
        secondNestedRadio: (item && item.radio) || null,
      });
    }, 0);
  };

  selectSecondNestedOption = (selectedReason) => {
    this.setState({
      selectSecondNestedOption: '',
    });
    this.timerID3 = setTimeout(() => {
      this.setState({
        selectSecondNestedOption: selectedReason,
      });
    }, 0);
  };

  getSpoiledItems = (items) => {
    const totalItems = Object.keys(items);
    return (
      totalItems &&
      totalItems.map((item) => {
        return {
          text: items[item].name,
          value: items[item].id,
          max_range: items[item].quantity,
        };
      })
    );
  };

  selectedSpoiledItems = (requesteditems) => {
    this.setState({
      requesteditems: requesteditems,
    });
  };

  addComment = (event) => {
    this.setState({
      comment: event.target.value,
    });
  };

  sendApproveData = () => {
    const {
      selectedReason,
      requesteditems,
      nestedRadio,
      nestedCheckbox,
      selectNestedCheckbox,
      selectedNestedReason,
      dropdown,
      selectedDropdownVal,
      nestedDropdown,
      selectednestedDropdownVal,
      secondNestedRadio,
      selectSecondNestedOption,
    } = this.state;
    const { sendAction, handoverData } = this.props;
    const { approve_view, request_id } = handoverData;
    const { radio } = approve_view;

    if (
      (dropdown && !selectedDropdownVal.length) ||
      (nestedDropdown && !selectednestedDropdownVal.length)
    ) {
      this.setState({
        dropdownError: true,
        dropdownErrorText: 'Please select some Issue.',
      });
      return;
    }
    if (
      (radio && radio.source && !selectedReason) ||
      (nestedRadio && !selectedNestedReason) ||
      (nestedCheckbox && !selectNestedCheckbox) ||
      !requesteditems ||
      (requesteditems && !Object.keys(requesteditems).length)
    )
      return false;

    let data = {},
      radioData = {},
      nestedCheckboxData = {},
      dropdownData = {},
      nestedRadioData = {},
      nestedDropdownData = {},
      secondNestedRadioData = {};

    if (radio && radio.source) {
      radioData = getFormData(radio, selectedReason);
    }
    if (dropdown) {
      dropdownData = getFormData(dropdown, selectedDropdownVal);
    }
    if (nestedRadio && nestedRadio.source) {
      nestedRadioData = getFormData(nestedRadio, selectedNestedReason);
    }
    if (nestedDropdown) {
      nestedDropdownData = getFormData(
        nestedDropdown,
        selectednestedDropdownVal,
      );
    }
    if (secondNestedRadio) {
      secondNestedRadioData = getFormData(
        secondNestedRadio,
        selectSecondNestedOption,
      );
    }
    if (nestedCheckbox) {
      nestedCheckboxData = getFormData(nestedCheckbox, selectNestedCheckbox);
    }

    Object.assign(
      data,
      radioData,
      dropdownData,
      nestedRadioData,
      nestedDropdownData,
      secondNestedRadioData,
      nestedCheckboxData,
    );
    data['items'] = requesteditems;
    data['request_id'] = request_id;
    sendAction(data);
  };

  render() {
    const { handoverData, goBack } = this.props;
    const {
      selectedReason,
      selectedDropdownVal,
      nestedRadio,
      nestedCheckbox,
      selectednestedDropdownVal,
      dropdownError,
      dropdownErrorText,
      secondNestedRadio,
    } = this.state;
    const { approve_view, request_items } = handoverData;
    if (!approve_view) return null;

    return (
      <div className='woApproveImageSection col'>
        <div className='box'>
          <div className='col pt10'>
            {/* <p className="titleHeading dark">Reason for approval</p> */}
            {approve_view.radio && approve_view.radio.source && (
              <React.Fragment>
                {approve_view.radio.title && (
                  <Heading title={approve_view.radio.title.text} />
                )}
                {approve_view.subtitle && (
                  <SubHeading title={approve_view.subtitle.text} />
                )}
                <RadioGroup
                  items={approve_view.radio.source}
                  selectOption={this.selectOption}
                  selectDropdown={this.selectDropdown}
                  selectedDropdownVal={selectedDropdownVal}
                  dropdownError={dropdownError}
                  dropdownErrorText={dropdownErrorText}
                />
              </React.Fragment>
            )}
          </div>
          {selectedReason && nestedRadio && (
            <div className='col pt10'>
              {nestedRadio.title && <Heading title={nestedRadio.title.text} />}
              {nestedRadio.subtitle && (
                <SubHeading title={nestedRadio.subtitle.text} />
              )}
              <RadioGroup
                items={nestedRadio.source}
                selectOption={this.selectNestedOption}
                selectDropdown={this.selectNestedDropdown}
                selectedDropdownVal={selectednestedDropdownVal}
                dropdownError={dropdownError}
                dropdownErrorText={dropdownErrorText}
              />
              {secondNestedRadio && (
                <div className='col pt10'>
                  {secondNestedRadio.title && (
                    <Heading title={secondNestedRadio.title.text} />
                  )}
                  {secondNestedRadio.subtitle && (
                    <SubHeading title={secondNestedRadio.subtitle.text} />
                  )}
                  <RadioGroup
                    items={secondNestedRadio.source}
                    selectOption={this.selectSecondNestedOption}
                  />
                </div>
              )}
            </div>
          )}
          {nestedCheckbox && (
            <div className='col pt10'>
              {nestedCheckbox.title && (
                <Heading title={nestedCheckbox.title.text} />
              )}
              {nestedCheckbox.subtitle && (
                <SubHeading title={nestedCheckbox.subtitle.text} />
              )}
              <CheckboxList
                items={nestedCheckbox.source}
                selectOptions={this.selectNestedCheckboxOption}
              />
            </div>
          )}

          {approve_view.radio && approve_view.radio.multi_select_range && (
            <div className='col pt20'>
              {approve_view.radio.multi_select_range.title && (
                <Heading
                  title={approve_view.radio.multi_select_range.title.text}
                />
              )}
              <MultiSelectView
                items={this.getSpoiledItems(request_items)}
                selectItems={this.selectedSpoiledItems}
              />
            </div>
          )}
        </div>

        <div className='btns pt10'>
          <div className='leftBtn'>
            <Button
              title={
                <p className='green'>
                  <span className='iconMarginR'>
                    <Check size={14} color='#50B547' />
                  </span>
                  <span>Approve</span>
                </p>
              }
              size='compressed'
              color='green'
              outline={true}
              onClick={this.sendApproveData}
            />
          </div>
          <div className='rightBtn'>
            <Button
              title='Go Back'
              size='compressed'
              color={grey.z700}
              onClick={goBack}
            />
          </div>
        </div>
      </div>
    );
  }
}
